/*  Shared  */
import { CellContext } from '@tanstack/react-table';
import { ApplicationBubbles } from 'application/Shared/Components/Avatars';
import { Application } from 'application/Shared/types/application';

/*  React  */
import React from 'react';

/**
 * Component that renders a cell containing applications bubbles
 * Uses the ApplicationBubbles component to display the data
 * @param props - Cell context props from react-table containing cell and row data
 * @returns JSX element displaying the applications bubbles
 */
export const ApplicationsBubblesCell = <TData,>({
    cell
}: CellContext<TData, Application[]>) => {
    const applications = cell.getValue() ?? [];

    return (
        <ApplicationBubbles
            max={3}
            applications={applications}
            tooltipPlacement="left"
        />
    );
};
